import type { NotificationOptions } from './types'

export const addAndFilterNotifications = (
  arr: NotificationOptions[],
  obj: NotificationOptions
): NotificationOptions[] => {
  const newArray = [...arr, obj]

  return newArray.filter(
    (value, index, self) =>
      index ===
      self.findIndex((t) => t.text === value.text && t.type === value.type)
  )
}
